module.exports = __webpack_public_path__ + "img/744.6f0fad0c.jpg";